<template>
  <div>
    <a-modal
      :visible="visible"
      destroy-on-close
      title="默认值选择"
      width="60%"
      centered
      ok-text="确认"
      cancel-text="取消"
      @ok="() => onSubmit()"
      @cancel="() => hideDialog()"
    >
      <div class="property-operations">
        <div class="data-filter">
          <a-input
            v-model="searchKeyword"
            class="search-keyword"
            clearable
            placeholder="请输入属性名称"
            @keyup.enter.native="doSearch"
          />
          <a-button
            class="search-btn"
            type="primary"
            @click="doSearch()"
          >
            搜索
          </a-button>
        </div>
      </div>
      <a-table
        :row-selection="{ selectedRowKeys, onChange: onSelectChange, type: 'checkbox' }"
        size="middle"
        :data-source="tableData"
        class="property-table"
        row-key="id"
      >
        <a-table-column
          key="identifier"
          title="属性标识符"
          data-index="identifier"
          align="center"
        >
          <template #default="scope">
            {{ scope }}
          </template>
        </a-table-column>
        <a-table-column
          key="encode"
          title="属性定义唯一标识"
          data-index="encode"
          align="center"
        >
          <template #default="scope">
            {{ scope }}
          </template>
        </a-table-column>
        <a-table-column
          key="name"
          title="属性名称"
          data-index="name"
          align="center"
        >
          <template #default="scope">
            {{ scope }}
          </template>
        </a-table-column>
        <a-table-column
          key="propertyType"
          title="节点类型"
          data-index="propertyType"
          align="center"
        >
          <template #default="scope">
            {{
              scope === 1 ? '父节点' : '子节点'
            }}
          </template>
        </a-table-column>
      </a-table>
      <a-pagination
        class="pagination"
        :current="pageInfo.page"
        :total="pageInfo.totalElements"
        :page-size="pageInfo.size"
        show-quick-jumper
        show-size-changer
        @change="onChange"
        @showSizeChange="onShowSizeChange"
      />
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PropertyGroupSelectModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parentIdentifier: {
      type: String,
      default: '',
    },
    selectedIdentifiers: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:visible', 'confirm'],
  data() {
    return {
      searchKeyword: '',
      tableData: [],
      selectedRowKeys: [],
      selectedProperties: {}, // keyed by property id (database id)
      selectedIdentifiersSet: [], // stores identifier strings for cross-page tracking
      pageInfo: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    }
  },
  methods: {
    async listProperties() {
      const params = {
        identifier: `${this.parentIdentifier}.`,
        name: this.searchKeyword || undefined,
        page: this.pageInfo.page - 1,
        size: this.pageInfo.size,
      }
      const response = await this.$apiManager.property.getProperties(params)
      this.tableData = response.data.elements
      this.pageInfo.totalElements = response.data.totalElements
      this.pageInfo.totalPages = response.data.totalPages
      // Sync selectedRowKeys: check which rows on this page match selected identifiers
      this.selectedRowKeys = this.tableData
        .filter(item => this.selectedIdentifiersSet.includes(item.identifier))
        .map(item => item.id)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      // Remove current page items from the selection map first
      const currentPageIds = this.tableData.map(item => item.id)
      currentPageIds.forEach((id) => {
        delete this.selectedProperties[id]
      })
      // Remove current page identifiers from the set
      const currentPageIdentifiers = this.tableData.map(item => item.identifier)
      this.selectedIdentifiersSet = this.selectedIdentifiersSet.filter(
        id => !currentPageIdentifiers.includes(id),
      )
      // Add back the newly selected rows from this page
      selectedRows.forEach((row) => {
        this.selectedProperties[row.id] = row
        if (!this.selectedIdentifiersSet.includes(row.identifier))
          this.selectedIdentifiersSet.push(row.identifier)
      })
      this.selectedRowKeys = selectedRowKeys
    },
    showDialog() {
      this.searchKeyword = ''
      this.pageInfo.page = 1
      this.selectedProperties = {}
      // Pre-populate from selectedIdentifiers prop
      this.selectedIdentifiersSet = this.selectedIdentifiers ? [...this.selectedIdentifiers] : []
      this.listProperties()
      this.$emit('update:visible', true)
    },
    hideDialog() {
      this.$emit('update:visible', false)
    },
    onSubmit() {
      // Merge: identifiers from selectedProperties (rows with full data) + remaining from set
      const rowsByIdentifier = Object.values(this.selectedProperties).map(prop => prop.identifier)
      const allIdentifiers = [...new Set([...rowsByIdentifier, ...this.selectedIdentifiersSet])]
      this.$emit('confirm', allIdentifiers)
      this.hideDialog()
    },
    doSearch() {
      this.pageInfo.page = 1
      this.listProperties()
    },
    onChange(pageNumber) {
      this.pageInfo.page = pageNumber
      this.listProperties()
    },
    onShowSizeChange(current, pageSize) {
      this.pageInfo.size = pageSize
      this.pageInfo.page = 1
      this.listProperties()
    },
  },
}
</script>

<style lang="less" scoped>
.popover-content {
  width: 50vw;
}
.content-layout {
  height: auto;
}
.green-btn {
  color: green;
  border: none;
}
.red-btn {
  color: red;
  border: none;
}
.property-operations {
  display: flex;
  justify-content: space-between;
  .add-btn {
    margin: 10px 0px;
    margin-left: 3%;
  }
  .data-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    .tip {
      color: #4c4c4c;
    }
    .date-picker-style {
      margin: 0 10px;
    }
    .search-options {
      width: 100px;
    }
    .search-keyword {
      width: 200px;
    }
    .search-btn {
      margin: 10px 0px;
      margin-left: 3%;
    }
  }
  .property-table {
    margin-top: 2%;
  }
}
.pagination {
  margin-top: 3%;
}
</style>
